import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetMessageQueueQuery,
  GetMessageQueueResponse,
} from '@hud/portal-dtos/webapp-message-queue.dto';
import { AxiosError } from 'axios';
import { ErrorResponse } from '@hud/portal-dtos/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export const QUEUE_ID = 'message-queue';

export default function useMessageQueue(
  flowId?: number,
  params?: GetMessageQueueQuery,
) {
  const { client, isReady } = useClient();
  return useQuery<GetMessageQueueResponse, AxiosError<ErrorResponse>>({
    queryKey: [QUEUE_ID, flowId, params],
    queryFn: async () => {
      const response = await client.get<GetMessageQueueResponse>(
        `${PORTAL_BASE}/messageQueues/${flowId}`,
        { params },
      );
      return GetMessageQueueResponse.parse(response.data);
    },
    enabled: flowId !== undefined && isReady,
    retry: (failureCount, error) => {
      if (
        error?.response?.status &&
        error.response.status > 401 &&
        error.response.status < 500
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
